export const ROLE_TYPE = {
  ADMIN: 'admin',
  GLOSSARY_EDITOR: 'glossary_editor',
  IS_BETA_USER: 'is_beta_user',
};

export const RESOURCE_TYPE = {
  CHAT: 'chat',
  CHAT_HISTORY: 'chat_history',
  GLOSSARIES: 'glossaries',
  COLLECTIONS: 'collections',
  REGIONS: 'regions',
  TACTIC_CONTEXTS: 'tactic_contexts',
  TACTIC_CONTEXT_TYPES: 'tactic_context_types',
  PLATFORM_NOTIFICATIONS: 'platform_notifications',
};

export const RESOURCE_ACTION_TYPE = {
  CREATE: 'create',
  READ: 'read',
  UPDATE: 'update',
  DELETE: 'delete',
};
